import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})


export class EventDataService {

  constructor(private httpclient: HttpClient) { }

  //uploadArticleImageData
  public uploadEventImageData(data): Observable<any> {
    return this.httpclient.post('event/uploadEventImageData', data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }
  // createEventText
  public createEventText(data): Observable<any> {
    return this.httpclient.post('event/createEventText', data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }

  // saveInstitutionEvents
  public saveInstitutionEvents(data): Observable<any> {
    return this.httpclient.post('event/saveInstitutionEvents', data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }

  // getImagePresignedUrl
  public getImagePresignedUrl(data): Observable<any> {
    return this.httpclient.post('event/aws/getImagePresignedUrl', data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }
  // getAllInstitutionEvents
  public getAllInstitutionEvents(data): Observable<any> {
    return this.httpclient.post('event/getAllInstitutionEvents/', data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }
  //getInstitutionEventsById
  public getInstitutionEventsById(data): Observable<any> {
    return this.httpclient.post('event/getInstitutionEventsById/', data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }
  // Get All Article For Institution By Institution Id
  public getAllEventsForInstitutionByInstitutionId(data): Observable<any> {
    return this.httpclient.post('event/getInstitutionEventsById/', data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }
  // EditInstitutionEventImageAfterSaved
  public editInstitutionEventImageAfterSaved(data): Observable<any> {
    return this.httpclient.post('event/EditInstitutionEventImageAfterSaved', data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }


  // update text
  public update(eventId, data): Observable<any> {
    return this.httpclient.put('event/' + eventId, data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }
  // delete 
  public delete(eventId): Observable<any> {
    return this.httpclient.delete('event/deleteInstitutionEvent/' + eventId).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }
  // getAllArticle
  public getAllEvents(id, data): Observable<any> {
    return this.httpclient.post('event/getAllInstitutionEventsForSPOC/' + id, data).pipe(
      tap((res) => {
        return res;
      }),
      catchError((error) => throwError(() => error))
    );
  }
  // getAllArticle
  public getAllEvent(id, data): Observable<any> {
    return this.httpclient.post('event/getAllInstitutionEventsForSPOC/' + id, data).pipe(
      tap((res) => {
        return res;
      }),
      catchError((error) => throwError(() => error))
    );
  }
  // approveArticle
  public approveEvents(id): Observable<any> {
    return this.httpclient.post('spoc/approveInstitutionEvents', id).pipe(
      tap((res) => {
        return res;
      }),
      catchError((error) => throwError(() => error))
    );
  }
  // getAllArticleInstitution
  public getAllEventsInstitution(data): Observable<any> {
    return this.httpclient.post('event/getAllInstitutionEventsForBlog/', data).pipe(
      tap((res) => {
        return res;
      }),
      catchError((error) => throwError(() => error))
    );
  }
  // // getInstitutionEventsById
  // public getInstitutionEventsById(id): Observable<any> {
  //   return this.httpclient.post('event/getInstitutionEventsById',id).pipe(
  //     tap((res) => {
  //       return res;
  //     }),
  //     catchError((error) => throwError(() => error))
  //   );
  // }
  // rejectArticle
  public rejectEvent(id): Observable<any> {
    return this.httpclient.post('spoc/rejectInstitutionEvents', id).pipe(
      tap((res) => {
        return res;
      }),
      catchError((error) => throwError(() => error))
    );
  }

  //delete Article image
  public deleteInstitutionEventImageAfterSaved(data): Observable<any> {
    return this.httpclient.post('event/deleteInstitutionEventImageAfterSaved', data).pipe(
      tap((res) => {
        return res;
      }),
      catchError((error) => throwError(() => error))
    );
  }

  //delete Article before save image
  public deleteInstitutionEventImagebeforeSaved(data): Observable<any> {
    return this.httpclient.post('event/aws/deleteEventImage', data).pipe(
      tap((res) => {
        return res;
      }),
      catchError((error) => throwError(() => error))
    );
  }
  // getAllArticleImageByInstitutionId
  public getAllEventImageByInstitutionId(id): Observable<any> {
    return this.httpclient.get('event/getAllEventImageByInstitutionId/' + id).pipe(
      tap((res) => {
        return res;
      }),
      catchError((error) => throwError(() => error))
    );
  }

  //SaveComments
  public saveComments(data): Observable<any> {
    return this.httpclient.post('comments/createInstitutionEventComments', data).pipe(
      tap((res) => {
        return res;
      }),
      catchError((error) => throwError(() => error))
    );
  }

  // getAllComments
  public getAllComments(id): Observable<any> {
    return this.httpclient.get('comments/getcommentsByInstitutionEventId/' + id).pipe(
      tap((res) => {
        return res;
      }),
      catchError((error) => throwError(() => error))
    );
  }
  // saveReplyToComments
  public reply(id, data): Observable<any> {
    return this.httpclient.put('comments/saveReplyToComments/' + id, data).pipe(
      tap((res) => {
        return res;
      }),
      catchError((error) => throwError(() => error))
    );
  }
  //save Event
  public saveEvent(data): Observable<any> {
    return this.httpclient.post('eventSchedule/scheduleEvent', data).pipe(
      tap((res) => {
        return res;
      }),
      catchError((error) => throwError(() => error))
    );
  }
  //save Event
  public saveArticle(data1): Observable<any> {
    return this.httpclient.post('event/createEvents', data1).pipe(
      tap((res) => {
        return res;
      }),
      catchError((error) => throwError(() => error))
    );
  }

  //Update Event
  public updateEvent(id, data): Observable<any> {
    return this.httpclient.put('eventSchedule/' + id, data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }

  // get All Event Schedule By Id
  public getAllEventScheduleById(id): Observable<any> {
    return this.httpclient.get('eventSchedule/getEventScheduleDataById/' + id).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }

  //Get All EVent by  Instution Id
  public getAllEventScheduleByInstutionId(id, data): Observable<any> {
    return this.httpclient.post('eventSchedule/getAllEventScheduleByInstitutionId/' + id, data).pipe(tap(res => {
      return res;
    }), catchError(error => throwError(() => error)));
  }

  //Delete the Event Schedule
  public deleteEventSchedule(eventscheduleId): Observable<any> {
    return this.httpclient.delete('eventSchedule/deleteEvent/' + eventscheduleId).pipe(
      tap((res) => {
        return res;
      }),
      catchError((error) => throwError(() => error))
    );
  }

  // Approve & Reject Event
  public approveRejectEvent(data): Observable<any> {
    return this.httpclient.post('eventSchedule/approveRejectEvent', data).pipe(
      tap((res) => {
        return res;
      }),
      catchError((error) => throwError(() => error))
    );
  }

  // Get All Public Event
  public publicEvent(data): Observable<any> {
    return this.httpclient.post('eventSchedule/getAllPublicEventSchedule', data).pipe(
      tap((res) => {
        return res;
      }),
      catchError((error) => throwError(() => error))
    );
  }
}
